import moment from 'moment';

export function formatDate(isoDate: string, pattern = 'MMMM yy', locale = 'de-AT') {
  moment.locale(locale)
  if (isoDate) {
    return moment(isoDate).format(pattern)
  }
  return ''
}

export function formatMonth(isoDate: string, locale = 'de-AT') {
  moment.locale(locale)
  if (isoDate) {
    return moment(isoDate).format('MMMM')
  }
  return ''
}

export function formatYear(isoDate: string, locale = 'de-AT') {
  moment.locale(locale)
  if (isoDate) {
    return moment(isoDate).format('yy')
  }
  return ''
}
